<script lang="ts">
  import Toast from './Toast.svelte';
  import { dismissToast, toasts } from './store.js';
</script>

<section class="toast-container" data-role="toasts">
  {#if $toasts}
    {#each $toasts as toast (toast.id)}
      <Toast type={toast.type} on:dismiss={() => dismissToast(toast.id)}>{toast.message}</Toast>
    {/each}
  {/if}
</section>

<style lang="scss">
  @use '../../styles/spacing';

  .toast-container {
    box-sizing: border-box;
    position: fixed;
    top: spacing.$s;
    right: spacing.$s;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: spacing.$xs;
    flex-direction: column;
  }
</style>
